export const GRID_AUTO_FLOW_CLASSES = {
    row: 'grid-flow-row',
    column: 'grid-flow-column',
    dense: 'grid-flow-dense',
    'row dense': 'grid-flow-row-dense',
    'column dense': 'grid-flow-col-dense',
};
export const applyGridAutoFlow = (gridAutoFlow) => [
    ...(gridAutoFlow ? [GRID_AUTO_FLOW_CLASSES[gridAutoFlow]] : []),
];
